const AnimationKeys = {
  HeroSpellcastLeft: 'hero-spellcast-left',
  HeroSpellcastRight: 'hero-spellcast-right',
  HeroThrustLeft: 'hero-thrust-left',
  HeroThrustRight: 'hero-thrust-right',
  HeroWalkLeft: 'hero-walk-left',
  HeroWalkRight: 'hero-walk-right',
  HeroSlashLeft: 'hero-slash-left',
  HeroSlashRight: 'hero-slash-right',
  HeroShootLeft: 'hero-shoot-left',
  HeroShootRight: 'hero-shoot-right',
  HeroHurt: 'hero-hurt',
};

export default AnimationKeys;
